import { DensityLarge, DensityMedium, DensitySmall } from '@mui/icons-material';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import { Button, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { GridDensity } from '@mui/x-data-grid-premium';
import { FC, memo, MouseEvent, useState } from 'react';

interface MyGridToolbarDensitySelectorProps {
  density: GridDensity;
  onDensityChange: (density: GridDensity) => void;
}

const MyGridToolbarDensitySelector: FC<MyGridToolbarDensitySelectorProps> = memo(({ density, onDensityChange }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDensityChange = (newDensity: GridDensity) => {
    onDensityChange(newDensity);
    handleClose();
  };

  return (
    <>
      <Button
        size="small"
        startIcon={<DensityMediumIcon />}
        onClick={handleClick}
        sx={{ minWidth: 'auto' }}
      >
        行間隔
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{
          paper: {
            sx: { padding: 0 }
          }
        }}
      >
        <MenuItem
          selected={density === 'compact'}
          onClick={() => handleDensityChange('compact')}
        >
          <ListItemIcon>
            <DensitySmall fontSize="small" />
          </ListItemIcon>
          コンパクト
        </MenuItem>
        <MenuItem
          selected={density === 'standard'}
          onClick={() => handleDensityChange('standard')}
        >
          <ListItemIcon>
            <DensityMedium fontSize="small" />
          </ListItemIcon>
          標準
        </MenuItem>
        <MenuItem
          selected={density === 'comfortable'}
          onClick={() => handleDensityChange('comfortable')}
        >
          <ListItemIcon>
            <DensityLarge fontSize="small" />
          </ListItemIcon>
          広め
        </MenuItem>
      </Menu>
    </>
  );
});

MyGridToolbarDensitySelector.displayName = 'GridToolbarDensitySelector';

export default MyGridToolbarDensitySelector;
